import React, { useState } from "react";
import calendarIcon from "../../assets/img/icons/calendar.svg";
import { INewsEventsData } from "../../exports/interfaces";
import { stripHtml } from "../../exports/functions";
import { Link } from "react-router-dom";
import { PdfViwer } from "../PdfViwer";
import { useMobile } from "../../hooks/custom/useMobile";

export const PublicNoticePost = ({ post }: { post: INewsEventsData }) => {
  const mobile = useMobile();

  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");
  const pdfUrl = post.file?.[0]?.media?.url;

  const redirectUrl =
    post.title === "Call for Expression of Interest"
      ? "/announcement/eoi"
      : post.title === "Competition for Logo Design"
        ? "/announcement/logoCompetition"
        : post.title === "घर जग्गा भाडामा दिने प्रस्ताव आह्वान"
          ? "/announcement/landLease"
          : post.title === "विश्वविद्यालयको शैक्षिक कार्यक्रम सुरु"
            ? "/announcement/mpp"
            : post.title === "Admission Open Now for MPP"
              ? "/announcement/admissionOpen"
              : pdfUrl
                ? "#"
                : stripHtml(post.link);

  const isVacancyTile =
    post.title === "Academic Post" || post.title === "Admin Post";
  const isInternal = isVacancyTile || redirectUrl.startsWith("/announcement/");
  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  return (
    <>
      <div
        className="col-lg-12 wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay="0.4s"
      >
        <div className="td_post td_style_1">
          <div className="td_post_info">
            <div
              className={`d-flex justify-content-between align-items-center gap-3 ${mobile ? "flex-column align-items-start" : ""}`}
            >
              <div style={{ maxWidth: mobile ? "100%" : "calc(100% - 150px)" }}>
                <div className="td_post_meta td_fs_14 td_medium td_mb_20">
                  <span>
                    <img src={calendarIcon} alt="calendar icon" />
                    {post.date}
                  </span>
                </div>
                <h2 className="td_post_title td_fs_24 td_medium td_mb_16">
                  {pdfUrl ? (
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openViewer(pdfUrl);
                      }}
                    >
                      {post.title}
                    </Link>
                  ) : (
                    <Link
                      to={redirectUrl}
                      target={isInternal ? "_self" : "_blank"}
                      rel={isInternal ? undefined : "noopener noreferrer"}
                    >
                      {post.title}
                    </Link>
                  )}
                </h2>
                <p className="td_post_subtitle td_heading_color td_opacity_7">
                  {post.sub_title}
                </p>
              </div>
              <div>
                <Link
                  to={pdfUrl ? "#" : redirectUrl}
                  target={pdfUrl || isInternal ? "_self" : "_blank"}
                  rel={pdfUrl || isInternal ? undefined : "noopener noreferrer"}
                  className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                  onClick={
                    pdfUrl
                      ? (e) => {
                          e.preventDefault();
                          openViewer(pdfUrl);
                        }
                      : undefined
                  }
                >
                  <span className="td_btn_in td_accent_color">
                    <span>Read More</span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PdfViwer
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        path={pdfPath}
      />
    </>
  );
};
